module.exports = __webpack_public_path__ + "img/dongbu.e2415d76.svg";